import { render, staticRenderFns } from "./ActivateInvite.vue?vue&type=template&id=b99694bc&scoped=true"
import script from "./ActivateInvite.vue?vue&type=script&lang=js"
export * from "./ActivateInvite.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=b99694bc&prod&scoped=true&lang=css&external"
import style1 from "./ActivateInvite.vue?vue&type=style&index=1&id=b99694bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99694bc",
  null
  
)

export default component.exports